import { useMemo, useState } from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import { seguirVariosParaAprobar } from '../../services/tramiteService';

/**
 * "Seguir varios" de Para aprobar (21-oct-2026): todo arranca sin seguir y quien quiere casi todos
 * marcaba uno por uno. Se elige la sección (o todas) y se siguen o se dejan de seguir todos sus
 * trámites de una vez; después se sacan con la estrella los pocos que no interesan.
 *
 * @param filas     las filas del tablero (con ambito, idTramite y seguido)
 * @param secciones [{ ambito, etiqueta }]
 * @param onHecho   recibe { ids, seguir } para actualizar la vista sin volver a pedir el tablero
 */
export default function ModalSeguirVarios({ open, onClose, filas = [], secciones = [], seccionInicial = '', onHecho }) {
    const [seccion, setSeccion] = useState(seccionInicial);
    const [guardando, setGuardando] = useState(false);

    const delaSeccion = useMemo(
        () => filas.filter((f) => !seccion || f.ambito === seccion),
        [filas, seccion]
    );
    const sinSeguir = delaSeccion.filter((f) => !f.seguido);
    const seguidos = delaSeccion.filter((f) => f.seguido);

    const aplicar = async (seguir) => {
        const ids = (seguir ? sinSeguir : seguidos).map((f) => f.idTramite);
        if (ids.length === 0) return;
        setGuardando(true);
        try {
            await seguirVariosParaAprobar(ids, seguir);
            toast.success(seguir ? `Ahora seguís ${ids.length} trámite(s).` : `Dejaste de seguir ${ids.length} trámite(s).`);
            onHecho?.({ ids, seguir });
            onClose?.();
        } catch {
            toast.error('No se pudo cambiar el seguimiento.');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflowY: 'auto' } }}>
            <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #e5e7eb' }}>
                <span className="fw-bold" style={{ color: '#1e293b' }}><i className="bi bi-star me-2" />Seguir varios</span>
                <IconButton onClick={onClose} size="small" aria-label="Cerrar"><CloseIcon fontSize="small" /></IconButton>
            </Box>
            <Box sx={{ p: 3 }}>
                <label className="form-label fw-semibold" htmlFor="seguir-varios-seccion">Tipo de trámite (sección)</label>
                <select id="seguir-varios-seccion" className="form-select mb-3" value={seccion} onChange={(e) => setSeccion(e.target.value)}>
                    <option value="">Todas las secciones</option>
                    {secciones.map((s) => <option key={s.ambito} value={s.ambito}>{s.etiqueta}</option>)}
                </select>
                <p className="small text-muted mb-3">
                    {delaSeccion.length} trámite(s) en Para aprobar: seguís {seguidos.length}. Te llegan los avisos de los
                    que seguís, por los canales que prendiste en <strong>Mis avisos</strong>.
                </p>
                <div className="d-flex flex-wrap gap-2">
                    <button type="button" className="btn btn-primary" disabled={guardando || sinSeguir.length === 0} onClick={() => aplicar(true)}>
                        <i className="bi bi-star-fill me-1" />Seguir todos ({sinSeguir.length})
                    </button>
                    <button type="button" className="btn btn-outline-secondary" disabled={guardando || seguidos.length === 0} onClick={() => aplicar(false)}>
                        Dejar de seguir todos ({seguidos.length})
                    </button>
                </div>
            </Box>
        </Dialog>
    );
}
